import type { PopoverProps as MantinePopoverProps } from '@mantine/core';
import { Popover as MantinePopover } from '@mantine/core';

import type { LockedProps } from '../types';

export type PopoverProps = Omit<MantinePopoverProps, LockedProps>;

export const Popover = (props: PopoverProps) => {
  return <MantinePopover {...props} />;
};

Popover.Target = MantinePopover.Target;
Popover.Dropdown = MantinePopover.Dropdown;
